import { render, staticRenderFns } from "./CurrentMonthOffersValue.vue?vue&type=template&id=7a6f8a93&scoped=true"
import script from "./CurrentMonthOffersValue.vue?vue&type=script&lang=ts"
export * from "./CurrentMonthOffersValue.vue?vue&type=script&lang=ts"
import style0 from "./CurrentMonthOffersValue.vue?vue&type=style&index=0&id=7a6f8a93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f8a93",
  null
  
)

export default component.exports